/* eslint-disable */
import debug from 'webmd-debug';
function googleRemarketingCode() {
	// once the page loads, get the DFP targets and pass to google pixel

	/*
	 * This function will execute only once, after which it becomes a no-op.
	 */
	
	//Disable google remarketing on webmdrx
	if (window.location.host.includes('webmdrx')){
		return;
	}

	var _once = function () {
		let params = {};
		//passing topic id as an event to gtag
		if(window.s_topic){
			gtag('event','page_view',{
				'send_to' : 'AW-875612316',
				'pt': window.s_topic 
			});
		}
		_once = function () {};

		if (typeof window.google_trackConversion !== 'undefined') {
			// for parameters with multiple values, pass parameter as a JavaScript array instead of string (https://support.google.com/adwords/answer/7280698)
			if (window && window.webmd && window.webmd.ads) {
				Object.keys(window.webmd.ads.pageTargets).forEach(index => {
					let value = window.webmd.ads.pageTargets[index];

					if (typeof value === 'string' && value.indexOf(",") > -1) {
						params[index] = value.split(",");
					} else {
						params[index] = value;
					}
				});
			} else {
				debug('Googletag does not exist');
			}

			window.google_trackConversion({
				google_conversion_id: 875612316,
				google_custom_params: params,
				google_remarketing_only: true,
			});
		}
	};

	// queue a callback to execute once GPT is ready
	if (typeof googletag !== 'undefined') {
		googletag.cmd.push(() => {
			/*
			* since all ad units on our pages have the same page targets,
			* we grab the targets out of the first ad that renders and pass it through to google pixel.
			* we can't rely on the targets in data-attributes because some targets are added dynamically during run-time, so we have to wait for slot render.
			* The conversion tracking call is guaranteed to execute just once even if there are multiple slotRenderEnded events.
			*/
			googletag.pubads().addEventListener('slotRenderEnded', function(e) {
				_once();
			});
		});
	} else {
		debug('Googletag does not exist');
	}
};

export { googleRemarketingCode };
